/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  ConflictErrorResponse,
  CurrentAdminUpdateRequest,
  PutApiCurrentAdminUpdate200,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type putApiCurrentAdminUpdateResponse200 = {
  data: PutApiCurrentAdminUpdate200
  status: 200
}

export type putApiCurrentAdminUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiCurrentAdminUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiCurrentAdminUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiCurrentAdminUpdateResponse409 = {
  data: ConflictErrorResponse
  status: 409
}
    
export type putApiCurrentAdminUpdateResponseSuccess = (putApiCurrentAdminUpdateResponse200) & {
  headers: Headers;
};
export type putApiCurrentAdminUpdateResponseError = (putApiCurrentAdminUpdateResponse400 | putApiCurrentAdminUpdateResponse401 | putApiCurrentAdminUpdateResponse403 | putApiCurrentAdminUpdateResponse409) & {
  headers: Headers;
};

export type putApiCurrentAdminUpdateResponse = (putApiCurrentAdminUpdateResponseSuccess | putApiCurrentAdminUpdateResponseError)

export const getPutApiCurrentAdminUpdateUrl = () => {


  

  return `/api/admin`
}

export const putApiCurrentAdminUpdate = async (currentAdminUpdateRequest: CurrentAdminUpdateRequest, options?: RequestInit): Promise<putApiCurrentAdminUpdateResponse> => {
  
  return customFetch<putApiCurrentAdminUpdateResponse>(getPutApiCurrentAdminUpdateUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      currentAdminUpdateRequest,)
  }
);}


